"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftOwnershipMatrixToJSON = exports.NftOwnershipMatrixFromJSONTyped = exports.NftOwnershipMatrixFromJSON = void 0;
function NftOwnershipMatrixFromJSON(json) {
    return NftOwnershipMatrixFromJSONTyped(json, false);
}
exports.NftOwnershipMatrixFromJSON = NftOwnershipMatrixFromJSON;
function NftOwnershipMatrixFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.NftOwnershipMatrixFromJSONTyped = NftOwnershipMatrixFromJSONTyped;
function NftOwnershipMatrixToJSON(value) {
    return value;
}
exports.NftOwnershipMatrixToJSON = NftOwnershipMatrixToJSON;
